import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Box, Label } from 'fw/components';
import { RichTextEditor, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals';

class RichTextEditorDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: "It's a sunny day"
			}
		};
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="RichTextEditor">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={12}>
							<Label htmlFor="default">Default</Label>
							<RichTextEditor enabled="enabled" name="default" />
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default RichTextEditorDemo;


// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Others/RichTextEditorDemo.js